import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  removeMessage as removeMessageAc, dismissMessage as dismissMessageAc, MESSAGE_TYPE_ERROR, MESSAGE_TYPE_SUCCESS,
} from '../../redux/messages/messageActions';

const getColor = (message) => {
  const type = message.get('type');
  switch (type) {
    case MESSAGE_TYPE_ERROR:
      return 'danger';
    case MESSAGE_TYPE_SUCCESS:
      return 'success';
    default:
      return 'info';
  }
};


class MessageDockUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.closeAlert = this.closeAlert.bind(this);
    this.removeAlert = this.removeAlert.bind(this);
  }

  closeAlert(message) {
    const { dismissMessage } = this.props;
    dismissMessage(message.get('id'));
  }

  removeAlert(message) {
    const { removeMessage } = this.props;
    removeMessage(message.get('id'));
  }

  render() {
    const { messages } = this.props;
    return (
      <div className="haz-message-dock">
        {messages.map(message => (
          <div className="row" key={message.get('id')}>
            <div className="col">
              <Alert
                transition={{
                  timeout: 150,
                  onExited: () => this.removeAlert(message),
                }}
                isOpen={message.get('visible')}
                className="text-center mb-1"
                color={getColor(message)}
                toggle={() => this.closeAlert(message)}
              >
                <strong>{message.get('message')}</strong>
              </Alert>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

MessageDockUnwrapped.propTypes = {
  messages: ImmutablePropTypes.list.isRequired,
  removeMessage: PropTypes.func.isRequired,
  dismissMessage: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  messages: state.getIn(['messages', 'messages']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  removeMessage: removeMessageAc,
  dismissMessage: dismissMessageAc,
}, dispatch);


export const MessageDock = connect(mapStateToProps, mapDispatchToProps)(MessageDockUnwrapped);
